import Reflux from 'reflux';

const AlertsActions = Reflux.createActions({
  list: { asyncResult: true },
  listPaginated: { asyncResult: true },
  listAllStreams: { asyncResult: true },
});

export default AlertsActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/alerts/AlertsActions.js